module.exports = __webpack_public_path__ + "static/media/RecomendaIlheus.be432bf8.jpg";